import { CopyIcon, GreenEllipse, PhysicalCardIcon, RedEllipse, VirtualCardIcon } from "../../../../Icons";
import { useSelector } from "react-redux";
import { FormatBalance } from "../../../../../helper";
import ToolTip from "../../../../Header/ToolTip";
import { useState } from "react";

export const ActiveCard = ({ hideBalance = false }) => {
  const { activeCard } = useSelector((state) => state.activeCard);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipText, setTooltipText] = useState("Copy Card Number");

  const formatCardNumber = (number) => number.replace(/(\d{4})(?=\d)/g, "$1 ");
  const formatCardExpiry = (expiry) => expiry.replace(/(\d{2})(?=\d)/g, "$1/");
  const showCopyIcon =
    activeCard.card_provider === "MM" &&
    activeCard.card_cvv &&
    activeCard.card_cvv !== "***";

  const nameLength = activeCard.name ? activeCard.name.length : 0;
  const nameMarginY = nameLength > 13 ? "my-0 !text-xs" : "my-4";

  const getCardBg = () => {
    if (activeCard.card_provider === "VM") {
      return activeCard.status === "Active"
        ? "bg-visa-card-bg"
        : "bg-visa-blocked-card-bg";
    } else if (activeCard.card_provider === "MM") {
      return "bg-master-card-bg";
    }
  };

  return (
    <div className="active-card space-y-3">
      {/* Status */}
      <div className="flex w-[314px] max-[360px]:w-[300px] items-center justify-between">
        <div className="flex items-center space-x-2">
          {activeCard.is_physical ? <PhysicalCardIcon /> : <VirtualCardIcon />}
          <p className="text-sm font-medium text-text-primary">
            {activeCard.is_physical ? "Physical Card" : "Virtual Card"}
          </p>
        </div>
        <span className="status-pill">
          {activeCard.status === "Active" ? <GreenEllipse /> : <RedEllipse />}
          <p className="status-text">{activeCard.status}</p>
        </span>
      </div>

      {/* Card */}
      <div
        className={`${getCardBg()} md:block relative rounded-2xl w-[314px] h-[196px] max-[360px]:w-[300px] bg-cover bg-center bg-no-repeat`}
      >
        <div
          className={`w-full h-full rounded-2xl p-2 ${
            activeCard.status !== "Active" ? "inactive-overlay" : "text-white"
          }`}
        >
          {/* Card number row */}
          <div
            onMouseEnter={() => showCopyIcon && setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onClick={() => {
              if (!showCopyIcon) return;
              navigator.clipboard.writeText(activeCard.card_number);
              setShowTooltip(true);
              setTooltipText("Copied!");
              setTimeout(() => {
                setShowTooltip(false);
                setTooltipText("Copy Card Number");
              }, 1000);
            }}
            className={`flex justify-between items-center ${
              activeCard.card_provider === "MM" ? "pt-16" : "mt-20 mb-5"
            }`}
          >
            <div className="card-number">
              <p>{formatCardNumber(activeCard.card_number)}</p>
              {showCopyIcon && <CopyIcon className="copy-icon" />}
            </div>
            <ToolTip
              text={tooltipText}
              showTooltip={showTooltip}
              arrowPosition="down"
              className="top-9 min-w-max"
            />
          </div>

          {/* Expiry & CVC */}
          {activeCard.card_provider === "MM" && (
            <div className="flex pb-2">
              <div className="flex items-center">
                <p className="card-meta-label">Expiry:</p>
                <p className="card-meta-value">
                  {activeCard.card_expiry &&
                    formatCardExpiry(activeCard.card_expiry)}
                </p>
              </div>
              <div className="flex items-center ml-2">
                <p className="card-meta-label">CVC:</p>
                <p className="card-meta-value">{activeCard.card_cvv}</p>
              </div>
            </div>
          )}

          {/* Debit label */}
          <div className="absolute bottom-14 right-6 z-1">
            <p className="debit-text">
              {activeCard.card_provider === "MM" ? "debit" : ""}
            </p>
          </div>

          {/* Cardholder name */}
          <div className="flex justify-between items-center">
            <div className={`card-name ${nameMarginY}`}>
              {activeCard.name?.toUpperCase()}
            </div>
          </div>
        </div>
      </div>

      {/* Balance */}
      {!hideBalance && (
        <div className="relative w-[314px] max-[360px]:w-[300px]">
          <div className="balance-wrapper">
            <p className="balance-label">Card balance</p>
            <p className="balance-value">
              $ {FormatBalance(activeCard.card_balance, false, true)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
